/*
  NOTE: This directive hasn't been unit tested yet due to the complex
  DOM logic. It's definitely do-able, just haven't had the time.
*/



const entrapFocus = {
  beforeMount(element, binding) {
    if (binding.value === false) {
      element.setAttribute('data-entrap', 'false');
    }

    else {
      element.setAttribute('data-entrap', 'true');
    }
  },



  mounted(element) {
    const inputSelector = 'a, button:not([disabled]):not([tabindex="-1"]), input:not([type="hidden"]):not([disabled]):not([readonly]):not([tabindex="-1"]), select, .select-input .text-input__input, textarea:not([type="hidden"]):not([disabled]):not([readonly]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';
    let allInputs = element.querySelectorAll(inputSelector);
    let visibleInputs;

    function keyDownHandler(event) {
      const shouldEntrap = element.getAttribute('data-entrap') === 'true';

      if (!shouldEntrap) {
        return;
      }

      if (event.keyCode === 9) {
        let needsToBringFocusInside = true;
        allInputs = element.querySelectorAll(inputSelector);
        visibleInputs = [];

        for (let i = 0; i < allInputs.length; i++) {
          if (allInputs[i].offsetHeight > 0) {
            visibleInputs.push(allInputs[i]);
          }
        }

        for (let i = 0; i < visibleInputs.length; i++) {
          if (document.activeElement.isEqualNode(visibleInputs[i])) {
            needsToBringFocusInside = false;
            break;
          }
        }

        if (needsToBringFocusInside) {
          visibleInputs[0].focus();
          event.preventDefault();
        }

        else {
          const firstInput = visibleInputs[0];
          const lastInput = visibleInputs[visibleInputs.length - 1];

          if (event.shiftKey && event.target === firstInput) {
            event.preventDefault();
            lastInput.focus();
          }

          else if (!event.shiftKey && event.target === lastInput) {
            event.preventDefault();
            firstInput.focus();
          }
        }
      }
    }

    element.$keyDownHandler = keyDownHandler;

    document.addEventListener('keydown', keyDownHandler, true);
  },



  beforeUnmount(element) {
    document.removeEventListener('keydown', element.$keyDownHandler, true);
  },



  updated(element, binding) {
    if (binding.value === false) {
      element.setAttribute('data-entrap', 'false');
    }

    else {
      element.setAttribute('data-entrap', 'true');
    }
  }
};



export default entrapFocus;
